import { api } from "../api";

/**
 * deviceUpdateStatusById - Function that updates on database an existing device status by id   
 * /devices/{id}/{status}  
 * method PUT 
 * @async-function
 */
const deviceUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/devices/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default deviceUpdateStatusById;
